export default defineNuxtRouteMiddleware(async (to) => {
  const { ensureLoaded } = useAuth()
  await ensureLoaded()
  // Gate on the DISPLAY role: a real admin previewing a lower role ("View as")
  // is blocked from /admin/* too, so the preview stays faithful (they exit the
  // preview via the banner to return). Real role still governs backend calls.
  const { hasDisplayRole } = useViewAs()

  const isAdmin = hasDisplayRole('Admin') || hasDisplayRole('Admin.Read') || hasDisplayRole('Admin.Write')
  if (isAdmin) return

  // ---------------------------------------------------------------------------
  // ADVISOR-RESTRICTED ADMIN
  //
  // Advisors get a narrow slice of the console — Manage Users and Refresh
  // Households — and nothing else. The allowlist is matched on the resolved path
  // so a deeper route (/admin/users/whatever) inherits its parent's permission
  // while an unlisted sibling (/admin/server) does not.
  //
  // This only stops navigation. Each BFF endpoint re-checks the caller, because
  // a hidden route is not access control.
  // ---------------------------------------------------------------------------
  if (hasDisplayRole('Advisor')) {
    const { ADVISOR_ADMIN_ROUTES } = usePermissions()
    const path = to.path.replace(/\/+$/, '') || '/'
    const allowed = ADVISOR_ADMIN_ROUTES.some(r => path === r || path.startsWith(`${r}/`))
    if (allowed) return
    // Landing on /admin itself: send them to the first page they can actually
    // use rather than bouncing them to /forbidden for clicking "Admin Console".
    if (path === '/admin') return navigateTo(ADVISOR_ADMIN_ROUTES[0] as string)
  }

  return navigateTo('/forbidden')
})
